<template>
    <div>
        <v-card-title style="word-break: break-word">
            <v-row align="center">
                <v-col class="grow text">
                    {{ligaName}}
                    <div v-if="bewerb" class="body-2">{{bewerb.getInfoText()}}</div>
                </v-col>
                <v-col class="shrink">
                    <div class="text-no-wrap">
                        <v-btn v-if="bewerb?.settings.liveStream"
                               @click="openStream(bewerb?.settings.liveStream)" icon class="d-inline-block mr-2">
                            <v-icon>mdi-video-box</v-icon>
                        </v-btn>
                        <v-btn @click="printMeisterschaftsBewerb()" icon><v-icon>mdi-printer</v-icon></v-btn>
                        <meisterschaft-edit-menu v-if="isAdmin" class="ml-2 d-inline-block"
                                                 @meisterschaftAction="meisterschaftAction"
                                                 :bewerb-existing="bewerb"/>
                    </div>
                </v-col>
            </v-row>
        </v-card-title>
    <!-- delete bewerb confirm dialog -->
        <confirm-dialog :open="deleteBewerbStatus.open" :header="deleteBewerbStatus.header"
                        @reply="processDeletion" query-parameter="confirmBewerbDelete">
            <div class="mb-2">Möchtest du wirklich den Bewerb
                <div class="font-weight-bold primary--text my-2 text-uppercase" style="font-size: 16px">'{{bewerbTitle}}'</div> der
                <span class="font-weight-bold">{{ligaName}}</span> für das Sportjahr
                <span class="font-weight-bold">{{sportJahr.replace('_', '/')}}</span> endgültig und unwiderruflich löschen</div>
            <div class="primary--text font-weight-bold">Alle bereits erfassten Ergebnisse gehen dadurch verloren!
                Zur Dokumentation wird deine Benutzer-Id und der Zeitpunkt der Löschung gespeichert</div>
            <v-checkbox v-model="confirmDelete" label="Ich bin mir sicher und möchte den Bewerb löschen!"
                        class="mt-3"/>
            <v-alert v-if="error" color="primary" text icon="mdi-alert">
                Bitte Klick das Bestätigungs-Kästchen oberhalb an!
            </v-alert>
        </confirm-dialog>
    </div>
</template>

<script>
import MeisterschaftEditMenu from "@/views/ergebnisdienst/meisterschaft/meisterschaftEditMenu.vue";
import ConfirmDialog from "@/components/elements/confirmDialog.vue";
import {MEISTERSCHAFT_BEWERBE} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "meisterschaftHeader",
    components: {ConfirmDialog, MeisterschaftEditMenu},
    props: ['ligaName', 'bewerb', 'landesverbandId', 'sportJahr'],
    computed: {
        isAdmin(){ return this.$store.getters["user/isMeisterschaftAdmin"](this.landesverbandId)},
        bewerbTitle(){ return this.meisterschaftBewerbe.find(b => b.value === this.bewerb?.settings?.bewerbTyp)?.label },
    },
    data: () => ({
        deleteBewerbStatus: {
            open: false,
            header: 'Bewerb endgültig löschen',
            question: '',
        },
        confirmDelete: false,
        meisterschaftBewerbe: MEISTERSCHAFT_BEWERBE,
        error: false,
    }),
    methods: {
        openStream(url){
            window.open(url, '_blank').focus();
        },
        meisterschaftAction(action){
            if ( action === 'deleteBewerb') {
                this.confirmDelete = false;
                this.deleteBewerbStatus.open = true;
            } else this.$emit('meisterschaftAction', action);
        },
        processDeletion(reply){
            if ( reply ) {
                if ( !this.confirmDelete ) {
                    this.error = true;
                    return;
                }
                this.bewerb.update(
                    {deletedBy: this.$store.state.user.uid},
                )
                this.$emit('meisterschaftAction', 'deleteBewerb');
            }
            this.deleteBewerbStatus.open = false;
        },
        printMeisterschaftsBewerb(){
            let routeData = this.$router.resolve({name: 'PrintMeisterschaft', query: {id: this.bewerb.id,
                docName: this.ligaName.replaceAll("/", "_").replaceAll("&", "+") + " " + this.sportJahr}});
            window.open(routeData.href, '_blank');
        }
    },
    watch: {
        confirmDelete(to){
            if ( to ) this.error = false;
        }
    }
}
</script>

<style scoped>

</style>